import {
  Build,
  DeviceHub,
  Flaky,
  Groups,
  ManageAccounts,
  People,
  PrecisionManufacturing,
  PriorityHigh,
  ReceiptLong,
  Sell,
  Tag,
  Task,
  TextFields,
} from "@mui/icons-material";
import { ERROR, INFO, SECONDARY, SUCCESS, WARNING } from "../common";
import { CONFIG_CONSTANTS_OPTIONS } from "./AppSettings";

export const TASK_FIELDS = {
  CUSTOMER: {
    ID: "customer_id",
    CONFIG_ID: "cust_id",
    LABEL: "Customer",
    ALTERNATE: "N/A",
    PLACEHOLDER: "Select Customer...",
    LIST_CONFIG_ID: CONFIG_CONSTANTS_OPTIONS.CUSTOMER,
    START_ICON: <Sell />,
  },
  STORE: {
    ID: "task_store_id",
    CONFIG_ID: "store_id",
    LABEL: "Store",
    ALTERNATE: "N/A",
    PLACEHOLDER: "Select Store...",
    LIST_CONFIG_ID: CONFIG_CONSTANTS_OPTIONS.STORE,
    START_ICON: <ReceiptLong />,
  },
  STORE_TITLE: {
    ID: "store_name",
    LABEL: "Store",
  },
  START_TIME: {
    ID: "exec_time_start",
    LABEL: "Task Start",
    ALTERNATE: "-",
  },
  END_TIME: {
    ID: "exec_time_end",
    LABEL: "Task End",
    ALTERNATE: "-",
  },
  TASK_ASSIGNED_DATE: {
    ID: "task_assign_date",
    LABEL: "Task Assigned Date",
    ALTERNATE: "Not Assigned",
  },
  EQUIPMENT: {
    ID: "task_eq_id",
    CONFIG_ID: "eq_id",
    LABEL: "Equipment",
    ALTERNATE: "N/A",
    PLACEHOLDER: "Select Equipment...",
    LIST_CONFIG_ID: CONFIG_CONSTANTS_OPTIONS.EQUIPMENT,
    START_ICON: <PrecisionManufacturing />,
  },
  CUSTOMER_NUMBER: {
    ID: "cust_rpt_no",
    LABEL: "Customer Report Number",
    ALTERNATE: "N/A",
    PLACEHOLDER: "Enter customer report number...",
    START_ICON: <Tag />,
  },
  TASK: {
    ID: "task_id",
    LABEL: "Task ID",
    ALTERNATE: "N/A",
    PLACEHOLDER: "Enter task ID...",
    START_ICON: <Task />,
  },
  TITLE: {
    ID: "task_title",
    LABEL: "Task Title",
    ALTERNATE: "N/A",
    PLACEHOLDER: "Enter task title...",
    START_ICON: <TextFields />,
  },
  PARENT_ID: {
    ID: "task_par_id",
    LABEL: "Parent Task",
    ALTERNATE: "N/A",
    PLACEHOLDER: "Select Parent Task...",
    LIST_CONFIG_ID: CONFIG_CONSTANTS_OPTIONS.TASKS,
    START_ICON: <DeviceHub />,
  },
  TYPE: {
    ID: "task_type",
    LABEL: "Task Type",
    ALTERNATE: "None",
    PLACEHOLDER: "Select Task Type...",
    LIST_CONFIG_ID: CONFIG_CONSTANTS_OPTIONS.TYPE,
    START_ICON: <Build />,
  },
  PRIORITY: {
    ID: "task_prty",
    LABEL: "Task Priority",
    ALTERNATE: "None",
    PLACEHOLDER: "Select Task Priority...",
    LIST_CONFIG_ID: CONFIG_CONSTANTS_OPTIONS.PRIORITY,
    START_ICON: <PriorityHigh />,
  },
  OWNER: {
    ID: "task_owner",
    CONFIG_ID: "ern",
    LABEL: "Task Owner",
    ALTERNATE: "None",
    PLACEHOLDER: "Select Task Owner...",
    LIST_CONFIG_ID: CONFIG_CONSTANTS_OPTIONS.EMPLOYEES,
    START_ICON: <ManageAccounts />,
  },
  ASSIGNED_EMPLOYEES: {
    ID: "task_assigned_to",
    CONFIG_ID: "ern",
    LABEL: "Task Assigned To",
    ALTERNATE: "No Assigned Employee",
    PLACEHOLDER: "Select Employees...",
    LIST_CONFIG_ID: CONFIG_CONSTANTS_OPTIONS.EMPLOYEES,
    START_ICON: <Groups />,
  },
  EXECUTOR_EMPLOYEES: {
    ID: "task_executors",
    CONFIG_ID: "ern",
    LABEL: "Task Executors",
    ALTERNATE: "No Executor Employees",
    PLACEHOLDER: "Select Employees...",
    LIST_CONFIG_ID: CONFIG_CONSTANTS_OPTIONS.EMPLOYEES,
    START_ICON: <People />,
  },
  STATUS: {
    ID: "task_status",
    LABEL: "Task Status",
    ALTERNATE: "None",
    PLACEHOLDER: "Select Status...",
    LIST_CONFIG_ID: CONFIG_CONSTANTS_OPTIONS.STATUS,
    START_ICON: <Flaky />,
  },
  TAGS: {
    ID: "task_tags",
    CONFIG_ID: "tag_id",
    LABEL: "Task Tags",
    ALTERNATE: "None",
    PLACEHOLDER: "Select Task Tags",
    LIST_CONFIG_ID: CONFIG_CONSTANTS_OPTIONS.TASK_TAGS,
    START_ICON: <Tag />,
  },
  DESCRIPTION: {
    ID: "task_desc",
    LABEL: "Task Description",
    ALTERNATE: "No Description Provided",
    PLACEHOLDER: "task description",
    LIST_CONFIG_ID: CONFIG_CONSTANTS_OPTIONS.PRIORITY,
  },
  PROBLEM: {
    ID: "task_prob",
    LABEL: "Problem Description",
    ALTERNATE: "No Description Provided",
    PLACEHOLDER: "problem description",
  },
  CAUSE: {
    ID: "task_prob_cause",
    LABEL: "Problem Cause Description",
    ALTERNATE: "No Cause Provided",
    PLACEHOLDER: "problem cause description",
  },
  REPAIR: {
    ID: "task_repair_act",
    LABEL: "Repair Action Description",
    ALTERNATE: "No Repair Action Provided",
    PLACEHOLDER: "repair action description",
  },
  RETAIN_PARTS: {
    ID: "retain_parts",
    LABEL: "Technician must return used parts",
    ALTERNATE: "Unknown",
  },
  CHECK_LOCATION: {
    ID: "check_location",
    LABEL: "End Task at Customer Location",
    ALTERNATE: "Unknown",
  },
  OVERTIME: {
    ID: "overtime",
    LABEL: "Overtime",
  },
  DATE_INSTALLATION: {
    ID: "date_installation",
    LABEL: "Date Installation",
    ALTERNATE: "-",
  },
  WARRANTY_DATE: {
    ID: "warranty_date",
    LABEL: "Warranty Date",
    ALTERNATE: "-",
  },
  STATE: {
    ID: "state",
    LABEL: "State",
    ALTERNATE: "-",
  },
};

export const TASKS_VALUE_MAPPING = {
  [TASK_FIELDS.PRIORITY.ID]: {
    4: { id: 4, label: "Normal", color: SUCCESS },
    3: { id: 3, label: "Medium", color: INFO },
    2: { id: 2, label: "High", color: WARNING },
    1: { id: 1, label: "Critical", color: ERROR },

    // Adding New Task Prioity Mapping
    "1A": { id: "1A", label: "Critical", color: ERROR },
    "1B": { id: "1B", label: "Critical", color: ERROR },
    "1C": { id: "1C", label: "Critical", color: ERROR },

    "2A": { id: "2A", label: "High", color: WARNING },
    "2B": { id: "2B", label: "High", color: WARNING },
    "2C": { id: "2C", label: "High", color: WARNING },

    "3A": { id: "3A", label: "Medium", color: INFO },
    "3B": { id: "3B", label: "Medium", color: INFO },
    "3C": { id: "3C", label: "Medium", color: INFO },

    "4A": { id: "4A", label: "Normal", color: SUCCESS },
    "4B": { id: "4B", label: "Normal", color: SUCCESS },
    "4C": { id: "4C", label: "Normal", color: SUCCESS },

    "TOWN CENTRE": { id: "TOWN CENTRE", label: "High", color: WARNING },
    "AWAY TOWN CENTRE": { id: "AWAY TOWN CENTRE", label: "Medium", color: INFO },
    "EAST COAST": { id: "EAST COAST", label: "Medium", color: INFO },
    "STANDARD": { id: "STANDARD", label: "Normal", color: SUCCESS },
    "EMERGENCY": { id: "EMERGENCY", label: "High", color: WARNING },
}
,
  [TASK_FIELDS.TYPE.ID]: {
    QMP: { id: "QMP", label: "QMP", color: SUCCESS },
    QMPSAN: { id: "QMPSAN", label: "QMP - PM/ Sanitation", color: SUCCESS },
    INS: { id: "INS", label: "Installation", color: INFO },
    PRJ: { id: "PRJ", label: "Project", color: SECONDARY },
    BRKDN: { id: "BRKDN", label: "Breakdown", color: ERROR },
    OTHR: { id: "OTHR", label: "Others", color: SECONDARY },
    WTDR: { id: "WTDR", label: "Withdrawal", color: WARNING },
    VRP: { id: "VRP", label: "VRP", color: INFO },
    SR: { id: "SR", label: "Site Reece", color: SECONDARY },
    DLVR: { id: "DLVR", label: "Delivery", color: INFO },
    PS: { id: "PS", label: "PM/Sanitation", color: WARNING },
    SPN_BRKDN: { id: "SPN_BRKDN", label: "Span Breakdown", color: ERROR },
    SPN_PRJ: { id: "SPN_PRJ", label: "Span Project", color: SECONDARY },
    SP_PRT_OD: { id: "SP-PRT_OD", label: "Spare Part Order", color: INFO },
    WRHS_NIKGIL: { id: "WRHS_NIKGIL", label: "Warehouse NIKGIL", color: SECONDARY },
  },
  [TASK_FIELDS.STATUS.ID]: {
    NEW_TASK: { id: "NEW_TASK", label: "New", color: INFO, tooltipLabel: "New Task" },
    ASSIGNED: { id: "ASSIGNED", label: "Assigned", color: INFO, tooltipLabel: "Task Executors Assigned" },
    PDG_START: { id: "PDG_START", label: "Pending", color: WARNING, tooltipLabel: "Pending Start" },
    ONGOING: { id: "ONGOING", label: "Ongoing", color: INFO, tooltipLabel: "Ongoing" },
    PDG_ADMIN_RV: { id: "PDG_ADMIN_RV", label: "Admin Review", color: SECONDARY, tooltipLabel: "Pending Admin Review" },
    PDG_MGR_RV: { id: "PDG_MGR_RV", label: "Manager Review", color: SECONDARY, tooltipLabel: "Pending Manager Review" },
    PDG_FINANCE_RV: { id: "PDG_FINANCE_RV", label: "Finance Review", color: SECONDARY, tooltipLabel: "Pending Finance Review" },
    PDG_CLIENT_FB: { id: "PDG_CLIENT_FB", label: "Client Feedback", color: SECONDARY, tooltipLabel: "Pending Client Feedback" },
    PDG_CLOSE: { id: "PDG_CLOSE", label: "Pending Close", color: ERROR, tooltipLabel: "Pending Close" },
    CLOSED: { id: "CLOSED", label: "Closed", color: SUCCESS, tooltipLabel: "Closed" },
  },
  [TASK_FIELDS.ASSIGNED_EMPLOYEES.ID]: {
    ADMIN: { id: "ADMIN", label: "Admin" },
    MGR: { id: "MGR", label: "Manager" },
    TECH: { id: "TECH", label: "Technician" },
    LEADER: { id: "LEADER", label: "Leader" },
    RSG: { id: "RSG", label: "Resign" },
    FNC: { id: "FNC", label: "Finance" },
  },
};

export const TAB_OPTIONS = {
  KEY: "active_tasks_tab",
  OPENED_TASKS: {
    ID: "opened-tasks",
    TAB_LABEL: "Opened Tasks",
    TABLE_LABEL: "Opened Tasks",
    FETCH_BY_STATUS_ARRAY: [
      "NEW_TASK",
      "ASSIGNED",
      "PDG_START",
      "ONGOING",
      "PDG_ADMIN_RV",
      "PDG_MGR_RV",
      "PDG_FINANCE_RV",
      "PDG_CLIENT_FB",
      "PDG_CLOSE",
    ],
    SUB_TABS: {
      OPENED: {
        ID: "opened-tasks-opened",
        TAB_LABEL: "Opened",
        FETCH_BY_STATUS_ARRAY: ["NEW_TASK", "ASSIGNED", "PDG_START"],
      },
      ONGOING: {
        ID: "opened-tasks-ongoing",
        TAB_LABEL: "Ongoing",
        FETCH_BY_STATUS_ARRAY: ["ONGOING"],
      },
      PDG_ADMIN_RV: {
        ID: "opened-tasks-admin-rv",
        TAB_LABEL: "Pending Admin Review",
        FETCH_BY_STATUS_ARRAY: ["PDG_ADMIN_RV"],
      },
      PDG_FINANCE_RV: {
        ID: "opened-tasks-finance-rv",
        TAB_LABEL: "Pending Finance Review",
        FETCH_BY_STATUS_ARRAY: ["PDG_FINANCE_RV"],
      },
      PDG_CLIENT_FB: {
        ID: "opened-tasks-client-fb",
        TAB_LABEL: "Pending Client Feedback",
        FETCH_BY_STATUS_ARRAY: ["PDG_CLIENT_FB"],
      },
      PDG_MGR_RV: {
        ID: "opened-tasks-mgr-rv",
        TAB_LABEL: "Pending Manager Review",
        FETCH_BY_STATUS_ARRAY: ["PDG_MGR_RV", "PDG_CLOSE"],
      },
    },
  },
  COMPLETED_TASKS: {
    ID: "completed-tasks",
    TAB_LABEL: "Task Report",
    TABLE_LABEL: "All Tasks",
    FETCH_BY_STATUS_ARRAY: [
      "NEW_TASK",
      "ASSIGNED",
      "PDG_START",
      "ONGOING",
      "PDG_ADMIN_RV",
      "PDG_MGR_RV",
      "PDG_FINANCE_RV",
      "PDG_CLIENT_FB",
      "PDG_CLOSE",
      "CLOSED",
    ],
  },
  BACKED_UP_TASKS: {
    ID: "backed-up-tasks",
    TAB_LABEL: "Backed Up Tasks",
    TABLE_LABEL: "Backed Up Tasks",
    FETCH_BY_STATUS_ARRAY: ["BACKED_UP"],
  },
};

/**
 * Maps user-friendly filter values to their corresponding IDs and labels based on TASKS_VALUE_MAPPING
 * @param {string} columnId - The field ID (e.g., "task_prty", "task_type", "task_status")
 * @param {string} filterValue - The filter value to map (e.g., "LOW", "MEDIUM", "QMP")
 * @returns {object} Object with valueId and valueLabel, or null if no mapping found
 */
export const mapFilterValueToId = (columnId, filterValue) => {
  if (!columnId || !filterValue) return null;

  const fieldMapping = TASKS_VALUE_MAPPING[columnId];
  if (!fieldMapping) return null;

  let mappedId = null;

  // Direct match (e.g., "QMP" or "CLOSED")
  if (fieldMapping[filterValue]) {
    mappedId = filterValue;
  } else if (columnId === TASK_FIELDS.PRIORITY.ID) {
    // Label-based match for priority (e.g., "LOW" -> 4, "MEDIUM" -> 3, etc.)
    for (const [id, mapping] of Object.entries(fieldMapping)) {
      if (mapping.label.toUpperCase() === filterValue.toUpperCase()) {
        mappedId = id;
        break;
      }
    }
  } else if (columnId === TASK_FIELDS.TYPE.ID) {
    // Label-based match for type (e.g., "INSTALLATION" -> "INS")
    for (const [id, mapping] of Object.entries(fieldMapping)) {
      if (mapping.label.toUpperCase() === filterValue.toUpperCase()) {
        mappedId = id;
        break;
      }
    }
  } else if (columnId === TASK_FIELDS.STATUS.ID) {
    // Label-based match for status (e.g., "NEW_TASK" -> "NEW_TASK")
    console.log("Mapping status filter value:", filterValue);
    for (const [id, mapping] of Object.entries(fieldMapping)) {
      if (mapping.tooltipLabel.toUpperCase() === filterValue.toUpperCase() || id === filterValue) {
        mappedId = id;
        break;
      }
    }
  }

  if (!mappedId) return null;

  // Get the mapping data for the found ID
  const mapping = fieldMapping[mappedId];
  if (!mapping) return null;

  // Return in the format that matches viewTasks.js transformOptions
  // Format: "valueId - label" (e.g., "2 - High", "INS - Installation")
  return {
    valueId: mappedId,
    valueLabel: `${mappedId} - ${mapping.label}`,
  };
};
